import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DatePipe} from '@angular/common';
import * as dayjs from 'dayjs';

@Component({
    selector: 'app-date-interval-time-picker',
    templateUrl: './date-interval-time-picker.component.html',
    styleUrls: ['./date-interval-time-picker.component.scss'],
})
export class DateIntervalTimePickerComponent implements OnInit {
    @Input() hint: string;
    @Input() initialDate: Date;
    @Input() idSuffix: string;
    @Input() timezone: string;
    @Input() required: boolean;
    @Input() endDate: boolean;
    @Output() dateChange: EventEmitter<any> = new EventEmitter();

    date: string;
    hour: number;
    minutes: number;
    amOrPm: string;

    displayHour: string;
    displayMinutes: string;


    ngOnInit() {
        if (this.initialDate) {
            const initialDate = dayjs(this.initialDate);

            const datepipe: DatePipe = new DatePipe('en-US');
            this.date = datepipe.transform(this.initialDate, 'yyyy-MM-dd');

            if (initialDate.hour() == 0) {
                this.hour = 12;
                this.amOrPm = 'AM';
            } else if (initialDate.hour() == 12) {
                this.hour = 12;
                this.amOrPm = 'PM';
            } else if (initialDate.hour() < 12) {
                this.hour = initialDate.hour();
                this.amOrPm = 'AM';
            } else {
                this.hour = initialDate.hour() - 12;
                this.amOrPm = 'PM';
            }
            this.minutes = initialDate.minute();
        }
        if (this.hour !== undefined && this.minutes !== undefined) {
            this.displayHour = this.hour.toString();
            this.displayMinutes = this.minutes.toString();
        }
    }

    getDate() {
        var date = dayjs.tz(this.date, this.timezone);
        return date.valueOf();
    }

    getHours() {
        this.hour = +this.displayHour;
        switch (this.amOrPm) {
            case "AM":
                if (this.hour == 12) {
                    return 0;
                } else {
                    return this.hour * 60 * 60000;
                }
                break;
            case "PM":
                if (this.hour == 12) {
                    return this.hour * 60 * 60000;
                } else {
                    return (this.hour * 60 * 60000) + (12 * 60 * 60000);
                }
                break;
        }
    }

    getMinutes() {
        this.minutes = +this.displayMinutes;
        return this.minutes * 60000;
    }

    onChange() {
        const now=new Date();

        if(this.date && !this.displayHour) {
            this.hour=now.getHours();
            this.displayHour=this.hour.toString();
            if(!this.amOrPm){
                if(this.hour<12){
                    this.amOrPm = "AM"
                } else {
                    if(this.hour>12) {
                        this.displayHour=(this.hour - 12).toString();
                    }
                    this.amOrPm = "PM"
                }
            }
        } else {
            this.hour=this.getHours();
        }

        if(this.date && !this.displayMinutes) {
            this.minutes=now.getMinutes();
            if(this.minutes<15){
                this.minutes=0;
            } else if(this.minutes<30){
                this.minutes=15;
            } else if(this.minutes<45){
                this.minutes=30;
            } else {
                this.minutes=45;
            }
            this.displayMinutes=this.minutes.toString();
        } else {
            this.minutes=this.getMinutes();
        }
       let newDate = new Date(this.getDate() + this.hour + this.minutes);
       this.dateChange.emit(new Date(newDate));
    }

    clear() {
        this.hour = null;
        this.minutes = null;
        this.amOrPm = null;
        this.date = null;
        this.displayHour = null;
        this.displayMinutes = null;
        this.onChange();
    }
}
